var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:eye-linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.96473 13.384C3.86845 12.418 3.32031 11.9341 3.32031 10.5C3.32031 9.065 3.86845 8.58288 4.96473 7.616C7.15342 5.6875 10.824 3.5 16.2177 3.5C21.6114 3.5 25.282 5.6875 27.4707 7.616C28.567 8.58375 29.1151 9.06587 29.1151 10.5C29.1151 11.935 28.567 12.4171 27.4707 13.384C25.282 15.3125 21.6114 17.5 16.2177 17.5C10.824 17.5 7.15342 15.3125 4.96473 13.384Z",
    stroke: "#081765",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0861 10.5C20.0861 11.1962 19.6784 11.8639 18.9528 12.3562C18.2272 12.8484 17.2431 13.125 16.2169 13.125C15.1907 13.125 14.2065 12.8484 13.4809 12.3562C12.7553 11.8639 12.3477 11.1962 12.3477 10.5C12.3477 9.80381 12.7553 9.13613 13.4809 8.64384C14.2065 8.15156 15.1907 7.875 16.2169 7.875C17.2431 7.875 18.2272 8.15156 18.9528 8.64384C19.6784 9.13613 20.0861 9.80381 20.0861 10.5Z",
    stroke: "#081765",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1);
export default __webpack_public_path__ + "static/media/eye1.86264bebeb0e99656601cc3340040fb0.svg";
export { ForwardRef as ReactComponent };